// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__12osl","inner":"Form_inner__BVWkI","range":"Form_range__3PnDB","name":"Form_name__3ZcHs","actions":"Form_actions__3ylM4"};